import React, { Component, cloneElement } from "react";
import {
    List,
    CreateButton,
    Pagination,
    Datagrid,
    TextField,
    Button,
    DateField,
    Filter,
    TextInput,
    RefreshButton,
    TopToolbar,
    usePermissions,
    useResourceContext,
    useRecordContext,
    CREATE,
    FunctionField,
    ReferenceField,
    AutocompleteInput,
    ReferenceInput
} from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import dataProvider from '../myRestProvider';

const CustomerFilters = (props) => {
    return (
        <Filter {...props}>
            <TextInput source="name" label="Name" defaultValue={""} />
            <TextInput source="file_type" label="File Type" defaultValue={""} />
            <ReferenceInput
                label="Sold To Name"
                source="business_id"
                reference="businesses"
                linkType="show"
                allowEmpty
            >
                <AutocompleteInput optionText="name" label="Sold To" />
            </ReferenceInput>
        </Filter>
    )
}

const DownloadPDFList = () => {

    const permissions = usePermissions();

    const extractId = (fileData) => {
        const match = fileData.match(/:id\s*=>\s*["']([^"']+)["']/);
        return match ? match[1] : null;
    };

    class DownloadTag extends Component {
        constructor(props) {
            super(props);
            this.state = {
                fileURL: null,
            };
        }

        sendImageData = () => {
            const { props } = this;

            const fileData = props.fileDetails;
            const fileId = extractId(fileData)

            if (fileId) {

                dataProvider(CREATE, "/customer_file_downloads/download_file", {
                    data: { file_id: fileId },
                })
                    .then((json) => {
                        if (json.data.status === "success") {
                            window.open(json.data.file_url, "_blank");
                        }
                    })
                    .catch((error) => console.log("error", error));
            }

        };
        render() {
            return (
                <div className="download-button" onClick={this.sendImageData}>
                    download
                </div>
            );
        }
    }

    const UploadPDFPagination = (props) => (
        <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
    );

    const CreateDownloadButton = () => {
        const record = useRecordContext();
        return (
            <Button>
                <div>
                    <DownloadTag fileDetails={record.file_data}></DownloadTag>
                </div>
            </Button>
        );
    };

    const ListActions = ({
        filterValues,
        total,
        maxResults,
        currentSort,
        exporter,
        permanentFilter,
        showFilter,
        displayedFilters,
        filters,
    }) => {
        const resource = useResourceContext();
        return (
            <TopToolbar>
                {filters &&
                    cloneElement(filters, {
                        resource,
                        showFilter,
                        displayedFilters,
                        filterValues,
                        context: "button",
                    })}
                <CreateButton basePath={resource} />
                <RefreshButton />
            </TopToolbar>
        );
    };

    const formatFileSize = (bytes) => {
        if (bytes == 0 || isNaN(bytes)) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        const size = bytes / Math.pow(1024, i);
        return `${size.toFixed(2)} ${units[i]}`;
    };


    return (
        <React.Fragment>
            <Scrollbars class="scroll-container" >
                <List
                    filters={<CustomerFilters />}
                    actions={<ListActions permissions={permissions} />}
                    pagination={<UploadPDFPagination />}
                    sort={{ field: 'created_at', order: 'DESC' }}
                    title="Customer Download List"
                    resource="customer_file_downloads"
                >
                    <Datagrid bulkActionButtons={false}>
                        <TextField source="name" label="Name" />
                        <ReferenceField
                            label="Sold To Name"
                            source="business_id"
                            reference="businesses"
                            link="show"
                            allowEmpty
                        >
                            <TextField source="name" />
                        </ReferenceField>
                        <DateField
                            label="Date & Time"
                            source="created_at"
                            sortable={false}
                            showTime
                            options={{
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            }}
                        />
                        <TextField source="file_type" label="Type" />
                        <FunctionField
                            source="file_size"
                            label="File Size"
                            render={record => formatFileSize(record?.file_size || 0)}
                        />
                        <CreateDownloadButton label="Download" />
                    </Datagrid>

                </List>
            </Scrollbars>
        </React.Fragment>
    )
};

export default DownloadPDFList;